import { useTheme } from '@mui/material'

const AlarmIcon = () => {
  const theme = useTheme()

  return (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.20718 1.70706L3.79297 0.292847L0.292969 3.79285L1.70718 5.20706L5.20718 1.70706ZM18.2072 0.292847L21.7072 3.79285L20.293 5.20706L16.793 1.70706L18.2072 0.292847ZM1.00008 11C1.00008 16.5228 5.47723 21 11.0001 21C16.5229 21 21.0001 16.5228 21.0001 11C21.0001 5.47711 16.5229 0.999953 11.0001 0.999953C5.47723 0.999953 1.00008 5.47711 1.00008 11ZM19.0001 11C19.0001 15.4182 15.4184 19 11.0001 19C6.5818 19 3.00008 15.4182 3.00008 11C3.00008 6.58168 6.5818 2.99995 11.0001 2.99995C15.4184 2.99995 19.0001 6.58168 19.0001 11ZM10.0001 12H7.00008V9.99995H10.0001V6.99995H12.0001V9.99995H15.0001V12H12.0001V15H10.0001V12Z"
        fill={theme.palette.custom.darkBlue2}
      />
    </svg>
  )
}

export default AlarmIcon
